import * as React from 'react';
import { AiFillExclamationCircle } from 'react-icons/ai';

type ErrorTextProps = {
  children: React.ReactNode;
  className?: string;
  iconSize?: number;
  hasIcon?: boolean;
};

export function ErrorText({
  children,
  className = '',
  iconSize = 24,
  hasIcon = true
}: ErrorTextProps) {
  return (
    <span className={`flex items-center gap-2 text-gray-700 ${className}`}>
      {hasIcon && <AiFillExclamationCircle size={iconSize} />}
      <span className="flex-1">{children}</span>
    </span>
  );
}
